import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Button, Tabs, Tab, Box, TextField, Grid, Card, Typography, MenuItem, InputAdornment, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import EditText from "../../components/editText";
import AddFaq from "../../Modals/addFaq";
import { useLazyGetCmsQuery, useLazyGetTaxQuery, useUpdateCmsMutation, useUpdateTexMutation } from "../../services/cms";
import countries from "../../helpers/constants/countries.json";
import { useFormik } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { showError, showToast } from "../../constants/toasts";
import Loader from "../../constants/Loader";
import toast from "react-hot-toast";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCms = () => {
  const isEdit = true;
  const navigate = useNavigate();
  const [updateCMS] = useUpdateCmsMutation();
  const [getCms] = useLazyGetCmsQuery();

  const [privacyPolicy, setPrivacyPolicy] = useState<string>("");
  const [aboutUs, setAboutUs] = useState<string>("");
  const [termsAndConditions, setTermsAndConditions] = useState<string>("");

  const [phoneCode, setPhoneCode] = useState("+91");
  const [phoneDisplay, setPhoneDisplay] = React.useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [valueTabs, setValueTabs] = React.useState(0);
  const [texData] = useLazyGetTaxQuery()
  const [updateTexMutation] = useUpdateTexMutation()
  // GST states
  const [defaultGst, setDefaultGst] = useState<string>("")
  const [defaultGstError, setDefaultGstError] = useState<string>("")
  type CountryTaxEntry = { country: string; gst: number; _id?: string };
  const [countryTaxes, setCountryTaxes] = useState<CountryTaxEntry[]>([])
  const [tempCountry, setTempCountry] = useState<string>("")
  const [tempGst, setTempGst] = useState<string>("")
  const [editIndex, setEditIndex] = useState<number | null>(null)
  const getCountryNameByCode = (code: string) => {
    const found = (countries as any[])?.find((c: any) => (c?.code || "").toUpperCase() === (code || "").toUpperCase());
    return found?.name || code;
  };
  const getCountryCodeByName = (name: string) => {
    const found = (countries as any[])?.find((c: any) => (c?.name || "").toUpperCase() === (name || "").toUpperCase());
    return found?.code || undefined;
  };
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const buildCmsBody = () => ({
    contactSupport: {
      email: formik.values.email,
      countryCode: (phoneCode.includes("+") ? "" : "+") + phoneCode,
      phone: formik.values.phone,
    },
    termsAndConditions,
    privacyPolicy,
    aboutUs,

  });


  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phone", phone?.replace(country.dialCode, ""));
    setPhoneDisplay(country?.dialCode + phone);
    setPhoneCode(country?.dialCode);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      phone: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Enter a valid email address"
        ),
      phone: Yup.string()
        .required("Phone number is required")
        .min(6, "Phone number must be at least 6 characters")
        .max(16, "Phone number must be at least 16 characters"),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);
      updateCms(1);
    },
  });

  const getCmsData = async () => {
    setIsLoading(true);
    try {
      const response = await getCms({}).unwrap();
      if (response.statusCode == 200) {
        setPrivacyPolicy(response?.data?.privacyPolicy);
        setTermsAndConditions(response?.data?.termsAndConditions);
        setAboutUs(response?.data.aboutUs);

        formik.setFieldValue("email", response.data?.contactSupport?.email);
        formik.setFieldValue("phone", response?.data?.contactSupport?.phone);
        setPhoneCode(response?.data?.contactSupport?.countryCode || "+91");
        setPhoneDisplay(
          (response?.data?.contactSupport?.countryCode || "+91") +
          (response?.data?.contactSupport?.phone || "")
        );
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  const getTaxData = async () => {
    setIsLoading(true);
    try {
      const response = await texData({}).unwrap();
      if (response.statusCode == 200) {
        const taxPayload: any = response?.data?.tax;
        if (Array.isArray(taxPayload)) {
          // Normalize incoming country value to ISO code if needed
          const normalized = taxPayload.map((t: any) => {
            const incoming = (t?.country || "").toString();
            let code = incoming;
            const isCodeLike = incoming.length === 2 && (countries as any[])?.some((c: any) => (c?.code || "").toUpperCase() === incoming.toUpperCase());
            if (!isCodeLike) {
              const byName = getCountryCodeByName(incoming);
              code = byName || incoming;
            }
            return { country: code.toUpperCase(), gst: Number(t.gst), _id: t._id } as CountryTaxEntry;
          });
          setCountryTaxes(normalized);
        }
        // prefill globalTax if provided
        if (response?.data?.globalTax !== undefined && response?.data?.globalTax !== null) {
          setDefaultGst(String(response.data.globalTax));
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const getSuccessMessage = (type: number) => {
    const message = "updated successfully";
    switch (type) {
      case 1:
        return `Contact details ${message}`;
      case 2:
        return `Privacy Policy ${message}`;
      case 3:
        return `Terms and Conditions ${message}`;
      case 4:
        return `About Us ${message}`;
      default:
        return message;
    }
  };

  const updateCms = async (type: number) => {

    try {
      const response = await updateCMS(buildCmsBody()).unwrap();
      if (response.statusCode === 200) {
        const message = getSuccessMessage(type);
        showToast(message);
      }
    } catch (error: any) {
      showError(error?.data?.message);
    }
  };

  const updateTex = async () => {
    try {
      // Validate default GST: must be 0-99 and max 2 chars
      if (defaultGst) {
        const cleanDefault = defaultGst.trim();
        if (cleanDefault.length > 2) {
          setDefaultGstError("GST should not exceed 2 digits");
          return;
        }
        const num = Number(cleanDefault);
        if (Number.isNaN(num) || num < 0) {
          setDefaultGstError("GST cannot be negative");
          return;
        }
      }
      const body: any = {
        globalTax: defaultGst ? Number(defaultGst) : undefined,
        tax: [
          // default GST can be represented by a pseudo country if required; otherwise omit
          ...countryTaxes.map((t) => ({ country: (t.country || "").toUpperCase(), gst: Number(t.gst) })),
        ],
      };
      const response = await updateTexMutation(body).unwrap();
      if (response.statusCode === 200) {
        showToast("GST updated successfully");
        toast.dismiss()
        setDefaultGstError("");
        setEditIndex(null);
      }
    } catch (error: any) {
      showError(error?.data?.message);
    }
  };

  const handleAddOrUpdateCountryTax = () => {
    if (!tempCountry) {
      showError("Country is required");
      return;
    }
    if (!tempGst || tempGst.trim() === "") {
      showError("GST is required");
      return;
    }
    const raw = tempGst.trim();
    if (raw.length > 2) {
      showError("GST should not exceed 2 digits");
      return;
    }
    const gstNumber = Number(raw);
    if (Number.isNaN(gstNumber)) {
      showError("GST must be a number");
      return;
    }
    if (gstNumber < 0) {
      showError("GST cannot be negative");
      return;
    }
    // Work with country ISO code
    const countryCode = tempCountry.trim().toUpperCase();
    const existingIndex = countryTaxes.findIndex((t) => (t.country || "").toUpperCase() === countryCode);
    if (editIndex !== null) {
      const updated = [...countryTaxes];
      updated[editIndex] = { ...updated[editIndex], country: countryCode, gst: gstNumber };
      setCountryTaxes(updated);
      setEditIndex(null);
      // persist immediately on edit as requested
      setTimeout(() => {
        updateTex();
      }, 0);
    } else {
      if (existingIndex !== -1) {
        showError("Country already exists");
        return;
      }
      setCountryTaxes((prev) => [...prev, { country: countryCode, gst: gstNumber }]);
      // optionally persist after add
      setTimeout(() => {
        updateTex();
      }, 0);
    }
    setTempCountry("");
    setTempGst("");
  };

  const handleDeleteCountryTax = (index: number) => {
    const updated = [...countryTaxes];
    updated.splice(index, 1);
    setCountryTaxes(updated);
    if (editIndex === index) setEditIndex(null);
    // persist immediately after delete
    setTimeout(() => {
      updateTex();
    }, 0);
  };
  const handleEditCountryTax = (index: number) => {
    const entry = countryTaxes[index];
    setTempCountry(entry.country);
    setTempGst(String(entry.gst));
    setEditIndex(index);
  };

  useEffect(() => {
    getCmsData();
    getTaxData()
  }, []);

  return (
    <MainContainer>
      <Loader isLoad={isLoading} />
      <div className="main_title">
        <h1>Manage CMS</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          CMS
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Contact Support" {...a11yProps(0)} />
              <Tab label="Privacy Policy" {...a11yProps(1)} />
              <Tab label="Terms and Conditions" {...a11yProps(2)} />
              <Tab label="About Us" {...a11yProps(3)} />
              <Tab label="GST" {...a11yProps(4)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <form
            className="form"
            onSubmit={(e) => {
              e.preventDefault();
              updateCms(1);
            }}
          >
            <div className="gap_p">
              <div className="control_group w_50">
                <label>Email Address</label>
                <TextField
                  hiddenLabel
                  className="text_field"
                  type={"email"}
                  name="email"
                  variant="outlined"
                  fullWidth
                  value={formik.values.email}
                  onChange={(e) => {
                    if (e.target.value == " ") return;
                    if (e.target.value.length <= 50) formik.handleChange(e);
                    else showError("Email can't exceed 50 characters");
                  }}
                  onBlur={formik.handleBlur}
                  helperText={formik.touched.email && formik.errors.email}
                  placeholder="Email"
                />
              </div>
              <div className="control_group w_50">
                <label>Phone Number</label>
                <PhoneInput
                  country={"us"}
                  placeholder="0 (000) 000-000"
                  enableSearch={true}
                  value={phoneDisplay}
                  onChange={handleChangePhone}
                  inputStyle={{ width: "100%" }}
                />
                {formik.touched.phone && formik.errors.phone ? (
                  <h6 className="err_msg">
                    {formik.touched.phone && formik.errors.phone}
                  </h6>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="form_btn">
              <Button type="submit" className="btn btn_primary">
                Save
              </Button>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              updateCms(2);
            }}
          >
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <EditText
                  content={privacyPolicy}
                  setContent={setPrivacyPolicy}
                />
              </Grid>
            </Grid>
            <div className="form_btn">
              {isEdit && (
                <Button size="large" type="submit" className="btn btn_primary">
                  Save
                </Button>
              )}
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              updateCms(3);
            }}
          >
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <EditText
                  content={termsAndConditions}
                  setContent={setTermsAndConditions}
                />
              </Grid>
            </Grid>

            <div className="form_btn">
              {isEdit && (
                <Button size="large" type="submit" className="btn btn_primary">
                  Save
                </Button>
              )}
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              updateCms(4);
            }}
          >
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <EditText content={aboutUs} setContent={setAboutUs} />
              </Grid>
            </Grid>

            <div className="form_btn">
              {isEdit && (
                <Button size="large" type="submit" className="btn btn_primary">
                  Save
                </Button>
              )}
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={4}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              updateTex();
            }}
          >
            <Card className="cards_1" style={{ padding: 16, marginBottom: 16 }}>
              <Typography variant="h6" className="heading" style={{ marginBottom: 12 }}>Global GST</Typography>
              <Grid container spacing={2}>
                <Grid item lg={6} md={8} sm={12} xs={12}>
                  <TextField
                    hiddenLabel
                    className="text_field"
                    type={"number"}
                    name="defaultGst"
                    variant="outlined"
                    fullWidth
                    label="Default GST"
                    value={defaultGst}
                    onChange={(e) => {
                      const next = e.target.value.replace(/[^0-9]/g, "").slice(0, 2);
                      setDefaultGst(next);
                      if (next && next.trim() !== "") setDefaultGstError("");
                    }}
                    placeholder="e.g., 18"

                  />
                  {defaultGstError ? (
                    <h6 className="err_msg" style={{ marginTop: 6 }}>{defaultGstError}</h6>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </Card>

            <Card className="cards_1" style={{ padding: 16 }}>
              <Typography variant="h6" className="heading" style={{ marginBottom: 12 }}>Country-wise GST</Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item lg={5} md={6} sm={12} xs={12}>
                  <TextField
                    select
                    hiddenLabel
                    type="text"
                    name="country"
                    variant="outlined"
                    fullWidth
                    label="Country"
                    placeholder="Select country"
                    value={tempCountry}
                    onChange={(e) => setTempCountry(e.target.value)}
                  >
                    {countries.map((c: any) => (
                      <MenuItem key={c.code} value={(c.code || "").toUpperCase()}>
                        {c.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item lg={5} md={4} sm={12} xs={12}>
                  <TextField
                    hiddenLabel
                    type="text"
                    name="gst"
                    variant="outlined"
                    fullWidth
                    label="GST (%)"
                    placeholder="e.g., 5"
                    value={tempGst}
                    inputProps={{ maxLength: 2, min: 0 }}
                    onChange={(e) => {
                      // allow only up to 2 digits and non-negative
                      const next = e.target.value.replace(/[^0-9]/g, "").slice(0, 2);
                      setTempGst(next);
                    }}

                  />
                </Grid>
                <Grid item lg={2} md={2} sm={12} xs={12}>
                  <Button onClick={handleAddOrUpdateCountryTax} fullWidth className="btn btn_primary">
                    {editIndex !== null ? "Update" : "Add"}
                  </Button>
                </Grid>
              </Grid>

              {countryTaxes?.length ? (
                <div className="gst_card_list" style={{ display: "grid", gap: 12, gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", marginTop: 16 }}>
                  {countryTaxes.map((item, index) => (
                    <Card key={`${item.country}-${index}`} className="gst_card" style={{ padding: 12 }}>
                      <div className="gst_card_header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div>
                          <Typography className="gst_country" style={{ fontWeight: 600 }}>{getCountryNameByCode(item.country)}</Typography>

                        </div>
                        <Typography className="gst_value" style={{ fontWeight: 700, fontSize: 18 }}>{item.gst}%</Typography>
                      </div>
                      <div className="gst_card_actions" style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 }}>
                        <Tooltip title="Edit">
                          <IconButton color="primary" size="small" onClick={() => handleEditCountryTax(index)}>
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <IconButton color="error" size="small" onClick={() => handleDeleteCountryTax(index)}>
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </Card>
                  ))}
                </div>
              ) : (
                <Typography variant="body2" color="text.secondary" style={{ marginTop: 12 }}>No country GST entries yet.</Typography>
              )}
            </Card>

            <div className="form_btn" style={{ marginTop: 16 }}>
              <Button type="submit" className="btn btn_primary">
                Save
              </Button>
            </div>
          </form>
        </CustomTabPanel>
      </div>

      <AddFaq
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </MainContainer>
  );
};

export default ManageCms;
